export const FIGMA_LINK_REGEX =
  /^(?:https:\/\/)?[\w.-]+\.?figma\.com\/([\w-]+)\/([0-9a-zA-Z]{22,128})(?:\/.*)?$/;
